import React, { Component } from 'react';
import RkHeader from '../../../GeneralComponents/RkHeader';
import Loading from '../../../GeneralComponents/LoadingComponen';
import FormCreate from './FormCreate';
import TableIndexWeb from './TableIndexWeb';
import Swal from "sweetalert2/dist/sweetalert2.js";

class Index extends Component {
    constructor(props){
        super(props)
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            modal: false,
            ErrorValues: true,
            modeEdit: false,
            id: "",

            form: {
                specific_area_id: "",
                proceso_id: "",
                date_of_analysis: "",
                responsable_id: "",
                description: "",
                users_ids: [],
            },

            selectedOption: {
                responsable_id: "",
                label: "Responsable"
            },

            selectedOptionUsers: [],

            selectedOptionAreas: {
                specific_area_id: "",
                label: "Área Específicas"
            },

            selectedOptionCargo: {
                proceso_id: "",
                label: "Proceso"
            },

            users: [],
            specific_areas: [],
            cargos: [],
        }
    }

    clearValues = () => {
        this.setState({
            ErrorValues: true,
            modeEdit: false,

            form: {
                specific_area_id: "",
                proceso_id: "",
                date_of_analysis: "",
                description: "",
                responsable_id: "",
                users_ids: [],
            },

            selectedOption: {
                responsable_id: "",
                label: "Responsable"
            },

            selectedOptionAreas: {
                specific_area_id: "",
                label: "Área Específicas"
            },

            selectedOptionUsers: [],

            selectedOptionCargo: {
                proceso_id: "",
                label: "Proceso"
            },
        })
    }

    messageSuccess = (response) => {
        Swal.fire({
            position: "center",
            type: `${response.type}`,
            title: `${response.success}`,
            showConfirmButton: false,
            timer: 1500,
        });
    };

    toogle = (from) => {
        if (from == "new") {
            this.setState({ modal: true })
            this.clearValues();
        } else {
            this.setState({ modal: false })
        }
    }

    validationForm = () => {
        if (this.state.form.date_of_analysis != "" &&
            this.state.form.responsable_id != ""
        ) {
            this.setState({ ErrorValues: true })
            return true
        }else{
            this.setState({ ErrorValues: false })
            return false
        }
    }

    //selects Config

    componentDidMount = () => {
        this.configSelect();
    }

    handleChangeAutocomplete = selectedOption => {
        this.setState({
            selectedOption,
            form: {
                ...this.state.form,
                responsable_id: selectedOption.value
            }
        });
    };

    handleChangeAutocompleteCargo = selectedOptionCargo => {
        this.setState({
            selectedOptionCargo,
            form: {
                ...this.state.form,
                proceso_id: selectedOptionCargo.value
            }
        });
    };

    handleChangeAutocompleteAreas = selectedOptionAreas => {
        this.setState({
            selectedOptionAreas,
            form: {
                ...this.state.form,
                specific_area_id: selectedOptionAreas.value
            }
        });
    };

    handleChangeAutocompleteUsers = selectedOptionUsers => {
        const selected = selectedOptionUsers || []
        this.setState({
            selectedOptionUsers: selected,
            form: {
                ...this.state.form,
                users_ids: selected.map(item => item.value)
            }
        })
    }

    configSelect = () => {
        let array = []
        let arrayAreas = []
        let arrayCargos = []

        this.props.users.map((item) => (
            array.push({label: item.name, value: item.id})
        ))

        this.props.specific_areas.map((item) => (
            arrayAreas.push({label: item.name, value: item.id})
        ))

        this.props.procesos.map((item) => (
            arrayCargos.push({label: item.name, value: item.id})
        ))

        this.setState({
            users: array,
            specific_areas: arrayAreas,
            cargos: arrayCargos
        })
    }

    HandleChange = (e) => {
        this.setState({
            form: {
                ...this.state.form,
                [e.target.name]: e.target.value
            }
        })
    }

    HandleClick = () => {
        if(this.validationForm() == true){
            if (this.state.modeEdit == true) {
                fetch(`/cause/cause_analyses/${this.state.id}`, {
                    method: 'PATCH', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.clearValues();
                    this.setState({ modal: false})
                    this.props.updateItem(data.register)
                    this.messageSuccess(data);
                });
            }else{
                fetch(`/cause/cause_analyses`, {
                    method: 'POST', // or 'PUT'
                    body: JSON.stringify(this.state.form), // data can be `string` or {object}!
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                .then(res => res.json())
                .catch(error => console.error("Error:", error))
                .then(data => {
                    this.clearValues();
                    this.setState({ modal: false})
                    this.props.updateData(data.register)
                    this.messageSuccess(data);
                });
            }
        }
    }

    edit = (cause) => {
        const participantIds = cause.participant_ids || []
        this.setState({
            modal: true,
            modeEdit: true,
            id: cause.id,

            form: {
                proceso_id: cause.proceso_id,
                specific_area_id: cause.specific_area_id,
                date_of_analysis: cause.date_of_analysis,
                description: cause.description,
                responsable_id: cause.responsable_id,
                users_ids: participantIds,
            },

            selectedOption: {
                responsable_id: cause.responsable_id,
                label: cause.responsable
                    ? `${cause.responsable.first_name} ${cause.responsable.first_last_name}`
                    : "Responsable"
            },

            selectedOptionAreas: {
                specific_area_id: cause.specific_area_id,
                label: `${cause.specific_area != undefined ? cause.specific_area.name : "Área Específicas"}`
            },

            selectedOptionCargo: {
                proceso_id: cause.proceso_id,
                label: `${cause.proceso != undefined ? cause.proceso.name : "Proceso"}`
            },

            selectedOptionUsers: this.state.users.filter(u => participantIds.includes(u.value)),
        })
    }

    delete = id => {
        Swal.fire({
            title: "¿Estás seguro?",
            text: "¡El registro será eliminado para siempre!",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#009688",
            cancelButtonColor: "#d33",
            confirmButtonText: "Eliminar",
            cancelButtonText: "Cancelar"
        }).then(result => {
            if (result.value) {
                fetch(`/cause/cause_analyses/${id}`, {
                    method: "delete",
                    headers: {
                        "X-CSRF-Token": this.token,
                        "Content-Type": "application/json"
                    }
                })
                    .then(response => response.json())
                    .then(response => {
                        this.props.loadData()
                        this.messageSuccess(response)
                    });
            }
        });
    };

    render() {
        return (
            <React.Fragment>
                <RkHeader
                    title={`${this.props.tenant.app_type == "beewo" ? "Investigación de causas" : "Análisis causa – raíz"}`}
                    subtitle={`${this.props.tenant.app_type == "beewo" ? "Método de análisis" : "Herramientas"}`}
                    titleNew={"Nuevo"}
                    icon="fas fa-toolbox"
                    onClickNew={this.toogle}
                    showNew={this.props.estados.crear}
                    showFilter={false}

                    //favorite module params
                    is_index={true}
                    url={this.props.current_url}
                />

                {this.state.modal && (
                    <FormCreate
                        //modal props
                        backdrop={"static"}
                        modal={this.state.modal}
                        toggle={this.toogle}
                        title={this.state.modeEdit == true ? "Editar análisis de causa" : "Nuevo"}

                        //form props
                        formValues={this.state.form}
                        onChangeForm={this.HandleChange}
                        submitForm={this.HandleClick}
                        errorValues={this.state.ErrorValues}
                        nameSubmit={this.state.modeEdit == true ? "Actualizar" : "Crear"}

                        //select user
                        handleChangeAutocomplete={this.handleChangeAutocomplete}
                        selectedOption={this.state.selectedOption}
                        users={this.state.users}

                        //select proceso / area
                        handleChangeAutocompleteAreas={this.handleChangeAutocompleteAreas}
                        selectedOptionAreas={this.state.selectedOptionAreas}
                        specific_areas={this.state.specific_areas}

                        //select participantes
                        handleChangeAutocompleteUsers={this.handleChangeAutocompleteUsers}
                        selectedOptionUsers={this.state.selectedOptionUsers}

                        //select cargos
                        handleChangeAutocompleteCargo={this.handleChangeAutocompleteCargo}
                        selectedOptionCargo={this.state.selectedOptionCargo}
                        cargos={this.state.cargos}

                        tenant={this.props.tenant}
                        showFile={false}
                    />
                )}

                {!this.props.isLoaded ? (
                    <TableIndexWeb
                        data={this.props.data}
                        estados={this.props.estados}
                        edit={this.edit}
                        delete={this.delete}
                        tenant={this.props.tenant}
                    />
                ) : (
                    <Loading />
                )}
            </React.Fragment>
        );
    }
}

export default Index;
